/**
 * Right-rail layers panel for the Post Editor Studio Mode.
 * Lists every text layer with visibility/lock toggles, z-order controls,
 * colour swatch and quick delete. Pure UI — all state ops come through props.
 */
export function LayerPanel({ layers, selectedIds, onSelect, onToggleVis, onToggleLock, onMove, onDelete, onRename }) {
  void onRename;
  return (
    <section className="bg-white rounded-xl border border-indigo-100 shadow-sm p-3" data-testid="pe-layer-panel">
      <div className="flex items-center gap-1.5 mb-2">
        <span className="text-xs font-bold uppercase tracking-wider text-indigo-900 flex-1">Katmanlar</span>
        <span className="text-[10px] text-stone-400">{layers.length}</span>
      </div>
      {layers.length === 0 ? (
        <p className="text-[11px] text-stone-400 italic text-center py-3">Katman yok</p>
      ) : (
        <ul className="space-y-1 max-h-[260px] overflow-y-auto pr-1">
          {/* Üstteki en önde (z-order için reverse göster) */}
          {[...layers].reverse().map((l, revIdx) => {
            const idx = layers.length - 1 - revIdx;
            const selected = selectedIds.includes(l.id);
            return (
              <li key={l.id}
                  className={`flex items-center gap-1 p-1 rounded border transition ${selected ? "bg-amber-50 border-amber-300" : "bg-stone-50 border-stone-200 hover:bg-indigo-50"}`}
                  onClick={(e) => onSelect(l.id, e.shiftKey)}
                  data-testid={`pe-lp-item-${idx}`}>
                <button type="button" onClick={(e) => { e.stopPropagation(); onToggleVis(l.id); }}
                        className="w-5 h-5 rounded hover:bg-stone-100 text-xs"
                        title={l.hidden ? "Göster" : "Gizle"}
                        data-testid={`pe-lp-eye-${idx}`}>
                  {l.hidden ? "⊝" : "👁"}
                </button>
                <button type="button" onClick={(e) => { e.stopPropagation(); onToggleLock(l.id); }}
                        className="w-5 h-5 rounded hover:bg-stone-100 text-xs"
                        title={l.locked ? "Kilidi aç" : "Kilitle"}
                        data-testid={`pe-lp-lock-${idx}`}>
                  {l.locked ? "🔒" : "🔓"}
                </button>
                <span className="text-[10px] font-mono font-semibold text-stone-500 w-5 text-center shrink-0">
                  #{idx + 1}
                </span>
                <span className="w-3 h-3 rounded-sm border border-stone-300 shrink-0"
                      style={{ background: l.color || "#ffffff" }}
                      title={l.color || "#ffffff"} />
                <span className="flex-1 text-[11px] text-stone-800 truncate" style={{ opacity: l.hidden ? 0.4 : 1 }}>
                  {l.text || <em className="text-stone-400">(boş)</em>}
                </span>
                <button type="button" onClick={(e) => { e.stopPropagation(); onMove(l.id, +1); }}
                        disabled={idx === layers.length - 1}
                        className="w-5 h-5 rounded hover:bg-stone-100 text-stone-500 disabled:opacity-30"
                        title="Öne getir (yukarı)" data-testid={`pe-lp-up-${idx}`}>▲</button>
                <button type="button" onClick={(e) => { e.stopPropagation(); onMove(l.id, -1); }}
                        disabled={idx === 0}
                        className="w-5 h-5 rounded hover:bg-stone-100 text-stone-500 disabled:opacity-30"
                        title="Arkaya al (aşağı)" data-testid={`pe-lp-down-${idx}`}>▼</button>
                <button type="button" onClick={(e) => { e.stopPropagation(); onDelete(l.id); }}
                        className="w-5 h-5 rounded hover:bg-red-50 text-red-600 text-xs"
                        title="Sil" data-testid={`pe-lp-del-${idx}`}>×</button>
              </li>
            );
          })}
        </ul>
      )}
      <p className="text-[9px] text-stone-400 mt-2 leading-tight">
        Üstteki katmanlar önde. Shift+tıkla çoklu seç · Göz & kilit yan ikonlarda.
      </p>
    </section>
  );
}
